<template>
    <div class="sc-user-input--picker-wrapper">
        <EmojiPicker v-if="isActive" :onEmojiPicked="_handleEmojiPicked" :onBlur="_handlePickerBlur" />
        <button @click.prevent="_openPicker" class="sc-user-input--emoji-icon-wrapper">
            <span class="sc-user-input--tooltip">{{ __('Insert EMOJI') }}</span>
            <!-- TODO extract svg -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 0.375C14.0625 0.375 16.0312 0.9375 17.8125 1.96875C19.5938 3 21 4.40625 22.0312 6.1875C23.0625 7.96875 23.625 9.9375 23.625 12C23.625 14.1094 23.0625 16.0312 22.0312 17.8125C21 19.5938 19.5938 21.0469 17.8125 22.0781C16.0312 23.1094 14.0625 23.625 12 23.625C9.89062 23.625 7.96875 23.1094 6.1875 22.0781C4.40625 21.0469 2.95312 19.5938 1.92188 17.8125C0.890625 16.0312 0.375 14.1094 0.375 12C0.375 9.9375 0.890625 7.96875 1.92188 6.1875C2.95312 4.40625 4.40625 3 6.1875 1.96875C7.96875 0.9375 9.89062 0.375 12 0.375ZM12 21.375C13.6875 21.375 15.2344 20.9531 16.6875 20.1094C18.0938 19.2656 19.2656 18.1406 20.1094 16.6875C20.9531 15.2812 21.375 13.6875 21.375 12C21.375 10.3125 20.9531 8.76562 20.1094 7.3125C19.2656 5.90625 18.0938 4.73438 16.6875 3.89062C15.2344 3.04688 13.6875 2.625 12 2.625C10.3125 2.625 8.71875 3.04688 7.3125 3.89062C5.85938 4.73438 4.73438 5.90625 3.89062 7.3125C3.04688 8.76562 2.625 10.3125 2.625 12C2.625 13.6875 3.04688 15.2812 3.89062 16.6875C4.73438 18.1406 5.85938 19.2656 7.3125 20.1094C8.71875 20.9531 10.3125 21.375 12 21.375ZM8.25 11.25C7.82812 11.25 7.45312 11.1094 7.17188 10.8281C6.89062 10.5469 6.75 10.1719 6.75 9.75C6.75 9.375 6.89062 9 7.17188 8.71875C7.45312 8.4375 7.82812 8.25 8.25 8.25C8.625 8.25 9 8.4375 9.28125 8.71875C9.5625 9 9.75 9.375 9.75 9.75C9.75 10.1719 9.5625 10.5469 9.28125 10.8281C9 11.1094 8.625 11.25 8.25 11.25ZM15.75 11.25C15.3281 11.25 14.9531 11.1094 14.6719 10.8281C14.3906 10.5469 14.25 10.1719 14.25 9.75C14.25 9.375 14.3906 9 14.6719 8.71875C14.9531 8.4375 15.3281 8.25 15.75 8.25C16.125 8.25 16.5 8.4375 16.7812 8.71875C17.0625 9 17.25 9.375 17.25 9.75C17.25 10.1719 17.0625 10.5469 16.7812 10.8281C16.5 11.1094 16.125 11.25 15.75 11.25ZM15.9375 14.6719C16.125 14.4375 16.3594 14.2969 16.6875 14.25C16.9688 14.25 17.25 14.3438 17.4844 14.5312C17.7188 14.7188 17.8594 15 17.9062 15.2812C17.9062 15.6094 17.8594 15.8906 17.6719 16.0781C16.9219 16.9219 16.0781 17.5781 15.0938 18.0469C14.1094 18.5156 13.0781 18.75 12 18.75C10.875 18.75 9.84375 18.5156 8.85938 18.0469C7.875 17.5781 7.03125 16.9219 6.32812 16.0781C6.14062 15.8906 6.04688 15.6094 6.09375 15.2812C6.09375 15 6.23438 14.7188 6.46875 14.5312C6.70312 14.3438 6.98438 14.25 7.3125 14.25C7.59375 14.2969 7.875 14.4375 8.0625 14.6719C8.53125 15.2344 9.14062 15.7031 9.84375 16.0312C10.5 16.3594 11.25 16.5 12 16.5C12.75 16.5 13.4531 16.3594 14.1562 16.0312C14.8125 15.7031 15.4219 15.2344 15.9375 14.6719Z"
                    fill="url(#paint0_linear)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear"
                        x1="-4.51747"
                        y1="-0.470881"
                        x2="38.6667"
                        y2="18.3532"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#8B65E6" />
                        <stop offset="1" stop-color="#5937B7" />
                    </linearGradient>
                </defs>
            </svg>
        </button>
    </div>
</template>

<script>
    import EmojiPicker from './EmojiPicker.vue'

    export default {
        components: { EmojiPicker },
        props: {
            onEmojiPicked: {
                type: Function,
                required: false,
                default: null
            },
            syncInput: {
                type: String,
                required: false,
                default: null
            }
        },
        data() {
            return {
                isActive: false
            }
        },
        methods: {
            _openPicker(e) {
                this.isActive = !this.isActive
            },
            _handlePickerBlur(evt) {
                if (!evt.currentTarget.contains(evt.relatedTarget)) {
                    this.isActive = false
                }
            },
            _handleEmojiPicked(emoji) {
                if (this.syncInput) {
                    const input = $(this.syncInput)
                    if (input[0].tagName === 'TEXTAREA') {
                        input.val(input.val() + emoji)
                        input.change()
                        input.focus()
                    } else {
                        input.html(input.html() + emoji)
                        input.change()
                        input.focus()
                        document.execCommand('selectAll', false, null)
                        document.getSelection().collapseToEnd()
                    }
                }

                this.onEmojiPicked && this.onEmojiPicked(emoji)
            }
        }
    }
</script>
